<template>
    <form ref="form" class="form">
        <b-form-group>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> Not Tipi </label> </b-col>
                <b-col sm="8"> <b-form-input id="accountNo" v-model="accountNo" placeholder="Not Tipini Giriniz" /></b-col>
            </b-row>
            <b-row>
                <b-col sm="4"> <label for="accountNo"> Görüntülenecek Yerler </label> </b-col>
                <b-col sm="8"> 
                    <div class="singleLine"> 
                        <b-form-checkbox> Trafik List </b-form-checkbox> 
                        <b-form-checkbox> Sinyal İşleme </b-form-checkbox> 
                    </div>  
                </b-col>
            </b-row>
        </b-form-group>
    </form>
</template>

<script>
    export default {
        name: "SubEventForm",
      
        
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/NoteTypeForm.vue